import axios from 'services/axios'
import apiService from './api'

export const employeesExport = async (employeesIndices: string, entityId: string, vertical: string) => {
  const endpoint = 'employees/export'

  if (!employeesIndices || !entityId) return

  const params = {
    employeesIndices,
    entityId,
    vertical,
  }
  const config = {
    params,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}
